// JsFromRoutes CacheKey 5c0373c0770904292c5b9df94c8b70b2
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@/utils/definePathHelper'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '(/:locale)/profiles/:profile_username/comps'),
}
